<template>
  <vx-card style="padding-left: 10px" id="editPage">
    <div style="float: right">
      <vs-button @click="saveData" v-if="canEdit" icon-pack="feather" class="m-2"
        >Save Details</vs-button
      >
    </div>

    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="left" vs-w="12">
      <vs-row vs-type="flex" vs-align="left" class="w-full">
        <div class="w-full m-5">
          <h5>Clinic Details</h5>
        </div>
      </vs-row>

      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
        <div class="w-full m-5">
          <vs-input
            :success="
              !errors.first('basic.clinicName') && clinicData.clinicName != ''
            "
            :disabled="!canEdit"
            val-icon-success="done"
            val-icon-danger="error"
            :danger="errors.first('basic.clinicName') ? true : false"
            v-validate="'required'"
            name="clinicName"
            :danger-text="errors.first('basic.clinicName')"
            data-vv-as="clinic name"
            label="Clinic Name"
            class="w-full"
            data-vv-scope="basic"
            v-model="clinicData.clinicName"
          />
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-align="left" vs-w="6">
        <div class="w-full m-5">
          <vs-input
          :disabled="!canEdit"
            :danger="errors.first('bestContactNumber') ? true : false"
            :success="
              !errors.first('bestContactNumber') && clinicData.bestContactNumber != ''
            "
            val-icon-success="done"
            val-icon-danger="error"
            name="phoneNumber"
            label="Phone Number (Optional)"
            v-model="clinicData.bestContactNumber"
            class="w-full"
          />
          <span class="text-danger text-sm error-text">{{
            errors.first("bestContactNumber")
          }}</span>
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
        <div class="w-full m-5">
        <vs-input
        :disabled="!canEdit"
          :danger="errors.first('basic.address') ? true : false"
          :danger-text="errors.first('basic.address')"
          data-vv-scope="basic"
          :success="
            !errors.first('basic.address') &&
            clinicData.address.displayAddress != ''
          "
          ref="autocomplete"
          val-icon-success="done"
          val-icon-danger="error"
          v-validate="'required'"
          data-vv-as="address"
          name="address"
          label="Clinic Address"
          placeholder="Clinic address"
          v-model="clinicData.address.displayAddress"
          class="w-full"
        />
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
        <div class="w-full m-5">
          <vs-input
          :disabled="!canEdit"
            :success="
              !errors.first('basic.postalAddress') &&
              clinicData.postalAddress != ''
            "
            val-icon-success="done"
            val-icon-danger="error"
            :danger="errors.first('basic.postalAddress') ? true : false"
            name="postalAddress"
            data-vv-scope="basic"
            :danger-text="errors.first('basic.postalAddress')"
            data-vv-as="postal address"
            label="Clinic Postal Address (Optional)"
            class="w-full"
            v-model="clinicData.postalAddress"
          />
        </div>
      </vs-col>
    </vs-row>

    <div id="resetPasswordContainer">
      <vs-card v-if="resetPassword == true">
        <h4 class="mb-2 ml-5 mt-2">Reset Password</h4>
        <form autocomplete="off">
          <vs-row
            vs-align="flex-start"
            vs-type="flex"
            vs-justify="left"
            vs-w="12"
          >
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <div class="w-full m-5">
                <vs-input
                  :success="
                    !errors.first('resetPassword.newPassword') && password != ''
                  "
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="
                    errors.first('resetPassword.newPassword') ? true : false
                  "
                  name="newPassword"
                  :danger-text="errors.first('resetPassword.newPassword')"
                  label="New Password"
                  class="w-full"
                  v-validate="{
                    required: true,
                    strongPassword: true
                  }"
                  data-vv-as="new password"
                  data-vv-scope="resetPassword"
                  ref="password"
                  icon-no-border
                  icon-pack="feather"
                  v-model="password"
                  :icon="passwordIcon"
                  :type="passwordType"
                  @click.native="showHidePassword($event)"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
              <div class="w-full m-5">
                <vs-input
                  label="Confirm Password"
                  :success="
                    !errors.first('resetPassword.confirmPassword') &&
                    confirmPassword != ''
                  "
                  val-icon-success="done"
                  val-icon-danger="error"
                  :danger="
                    errors.first('resetPassword.confirmPassword') ? true : false
                  "
                  name="confirmPassword"
                  :danger-text="errors.first('resetPassword.confirmPassword')"
                  v-validate="'required|confirmed:password'"
                  data-vv-as="confirm password"
                  data-vv-scope="resetPassword"
                  class="w-full"
                  icon-no-border
                  icon-pack="feather"
                  v-model="confirmPassword"
                  :icon="confirmPasswordIcon"
                  :type="confirmPasswordType"
                  @click.native="showHideConfirmPassword($event)"
                />
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6">
              <div class="w-full m-5">
                <vs-button
                  size="lg"
                  @click="changePassword"
                  icon-pack="feather"
                  class="mr-2"
                  >Reset Password</vs-button
                >
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6">
              <div class="w-full m-5" align="right">
                <vs-button
                  @click="resetPassword = false"
                  color="danger"
                  icon-pack="feather"
                  class="mr-2"
                  >Cancel</vs-button
                >
              </div>
            </vs-col>
          </vs-row>
        </form>
      </vs-card>
    </div>
  </vx-card>
</template>

<script>
import { mapActions } from 'vuex';
import { Validator } from 'vee-validate';
import axios from '@/axios';
import { EventBus } from '../../../../main';
import { loadGoogleMapsPlaces } from '../../../../utils/loadGoogleMapPlacesAPI';

const dict = {
  custom: {
    bestContactNumber: {
      required: 'Please enter your best contact number',
    },
    newPassword: {
      required: 'Please enter your password',
      min: 'Password must be at least 10 characters',
      regex: 'Must contain at least one uppercase letter, one lowercase letter, one digit and one special character',
    },
    confirmPassword: {
      required: 'Please enter your confirm password',
      confirmed: 'The password confirmation does not match',
    },
  },
};

Validator.localize('en', dict);

export default {
  name: 'clinicEditDetail',
  inject: ['$validator'],
  props: {
    backRoute: {
      type: String,
      default: 'SuperAdminClinic',
    },
    canEdit:{
      type: Boolean,
      default: true,
    },
  },

  components: {
  },
  data: () => ({
    isRequired: true,
    discounts: [],
    suppliers: [],
    validationKeys: {
      showIsResidentialAddressError: false,
      showIntendToSecureS4MedicationError: false,
      showHaveAdrenalineAndHyalaseInClinicError: false,
    },
    statusChangedClick: false,
    adminApprovalChangeClick: false,
    discountEnableChangeClick: false,
    clinicId: '',
    password: '',
    confirmPassword: '',
    popUpDelete: false,
    clinicData: {
      isProfileCompleted: false,
      clinicAssignedSuppliers: [],
      firstName: '',
      lastName: '',
      companyName: '',
      clinicName: '',
      abn: '',
      address: {
        displayAddress: '',
        state: '',
        suburb: '',
        postCode: '',
        geometry: { type: 'Point', coordinates: [] },
      },
      postalAddress: '',
      bestContactName: '',
      bestContactNumber: '',
      bestContactEmail: '',
      billingEmail: '',
      invoiceEmail: '',
      clinicProductDiscountId: null,
      isAccessPaymentTerms: false,
      isEnableProductDiscount: false,
      status: false,
      hasApprovedByAdmin: false,
      emailVerifiedAt: null,
      contactNumber: '',
      instagram: '',
      facebook: '',
      website: '',
      clinicAddress1: '',
      isResidentialAddress: '',
      haveAdrenalineAndHyalaseInClinic: '',
      intendToSecureS4Medication: '',
      abnCertificate: '',
      councilPermits: [],
      poisonsCertificate: [],
      clinicOpeningHours: {
        mondays: '',
        tuesdays: '',
        wednesdays: '',
        thursdays: '',
        fridays: '',
        saturdays: '',
        sundays: '',
      },
      clinicFrontPhoto: [],
      clinicFloorPhoto: [],
      clinicTreatmentBedPhoto: [],
      clinicDrawingUpAreaPhoto: [],
      clinicFridgePhoto: [],
      clinicDrugStoragePhoto: [],
      clinicBinsPhoto: [],
      clinicRoomLockPhoto: [],
      clinicEpipenAndHyalasePhoto: [],
      removedImages: [],
    },
    resetPassword: false,
    checkDisplayAddress: '',
    addressData: [],
    passwordType: 'password',
    passwordIcon: 'icon icon-eye-off',
    confirmPasswordType: 'password',
    confirmPasswordIcon: 'icon icon-eye-off',
  }),
  methods: {
    ...mapActions('clinic', [
      'fetchClinicsDetail',
      'updateClinicDetail',
      'resetClinicPassword',
      'deleteClinic',
      'removeClinicImages',
    ]),
    ...mapActions('discount', ['fetchDiscountList']),
    ...mapActions('storeProducts', ['fetchSuppliers']),
    resetPasswordHandler() {
      this.resetPassword = true;
      window.scrollTo(0, document.body.scrollHeight);
    },
    async changePassword() {
      let self = this;
      const isValid = await this.$validator.validateAll('resetPassword');
      if (isValid) {
        await this.resetClinicPassword({
          id: this.clinicId,
          data: {
            password: this.password,
            confirmPassword: this.confirmPassword,
          },
        }).then(() => {
          self.password = '';
          self.confirmPassword = '';
          self.$validator.reset();
          self.$vs.notify({
            title: 'Clinic password reset',
            text: 'Clinic\'s password reset Successfully.',
            color: 'success',
          });
        });
      }
    },
    determineFileType(str) {
      var res = str.substring(str.length - 3, str.length);
      return res;
    },
    uploadImage(event, key = 'profileImage', loadingClass = '') {
      this.$vs.loading({
        background: '#fff',
        color: '#626262',
        container: `.${loadingClass}`,
        scale: 0.45,
      });
      let self = this;
      let data = new FormData();
      data.append('profileImage', event.target.files[0]);
      let config = {
        header: {
          'Content-Type': 'image/png',
        },
      };
      axios
        .post('/api/v1/doctors/upload?key=' + key, data, config)
        .then((res) => {
          if (key === 'abnCertificateUpload') {
            document.getElementById('abnCertificateId').style.borderColor =
              '#cccccc';
            self.clinicData.abnCertificate = res.data.Location;
            this.errors.remove('abnCertificate');
          }

          this.$vs.loading.close(`.${loadingClass} > .con-vs-loading`);
        })
        .catch((err) => {
          this.$vs.loading.close(`.${loadingClass} > .con-vs-loading`);
          if (err && err.status === 415) {
            this.$vs.notify({
              title: 'Upload Failed',
              text: 'File Format Not Supported',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          } else {
            this.$vs.notify({
              title: 'Upload Failed',
              text: 'Please try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          }
        });
    },
    removeImage(imageUrl, selector, loadingClass) {
      let self = this;

      self.clinicData[loadingClass] = self.clinicData[loadingClass].filter(
        (value) => value.photoUrl != imageUrl
      );

      self.clinicData.removedImages.push(imageUrl);
    },
    showHidePassword(event) {
      if (
        event.target.className ===
          'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye-off null icon-no-border' ||
        event.target.className ===
          'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye null icon-no-border'
      ) {
        this.passwordType === 'password'
          ? (this.passwordType = 'text')
          : (this.passwordType = 'password');
        this.passwordIcon === 'icon icon-eye-off'
          ? (this.passwordIcon = 'icon icon-eye')
          : (this.passwordIcon = 'icon icon-eye-off');
      }
      return true;
    },
    showHideConfirmPassword(event) {
      if (
        event.target.className ===
          'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye-off null icon-no-border' ||
        event.target.className ===
          'vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon icon-eye null icon-no-border'
      ) {
        this.confirmPasswordType === 'password'
          ? (this.confirmPasswordType = 'text')
          : (this.confirmPasswordType = 'password');
        this.confirmPasswordIcon === 'icon icon-eye-off'
          ? (this.confirmPasswordIcon = 'icon icon-eye')
          : (this.confirmPasswordIcon = 'icon icon-eye-off');
      }
      return true;
    },
    async getClinicDetail(id) {
      let self = this;
      await this.fetchClinicsDetail(id)
        .then((res) => {
          const clinic = res.data.data;
          self.clinicId = clinic._id;
          self.clinicData.firstName = clinic.firstName;
          self.clinicData.lastName = clinic.lastName;
          self.clinicData.companyName = clinic.companyName;
          self.clinicData.clinicName = clinic.clinicName;
          self.clinicData.abn = clinic.abn;
          self.clinicData.streetAddress = clinic.address
            ? clinic.address.displayAddress
            : '';
          self.clinicData.postalAddress = clinic.postalAddress;
          self.clinicData.bestContactName = clinic.bestContactName;
          self.clinicData.bestContactNumber = clinic.bestContactNumber;
          self.clinicData.bestContactEmail = clinic.bestContactEmail;
          self.clinicData.billingEmail = clinic.billingEmail;
          self.clinicData.invoiceEmail = clinic.invoiceEmail;
          self.clinicData.isAccessPaymentTerms =
            typeof clinic.isAccessPaymentTerms !== 'undefined'
              ? clinic.isAccessPaymentTerms
              : false;
          self.clinicData.isEnableProductDiscount =
            typeof clinic.isEnableProductDiscount !== 'undefined'
              ? clinic.isEnableProductDiscount
              : false;
          self.clinicData.clinicProductDiscountId =
            clinic.clinicProductDiscountId
              ? clinic.clinicProductDiscountId
              : null;
          self.clinicData.clinicAssignedSuppliers =
            clinic.clinicAssignedSuppliers
              ? clinic.clinicAssignedSuppliers
              : [];
          self.clinicData.address = clinic.address;
          self.clinicData.status = clinic.status === 'Active' ? false : true;
          self.checkDisplayAddress = clinic.address.displayAddress;
          self.clinicData.hasApprovedByAdmin = clinic.hasApprovedByAdmin;
          self.clinicData.emailVerifiedAt = clinic.emailVerifiedAt;
          self.clinicData.email = clinic.email;
          self.clinicData.bestContactNumber = clinic.bestContactNumber
            ? clinic.bestContactNumber
            : '';
          self.clinicData.instagram = clinic.instagram ? clinic.instagram : '';
          self.clinicData.facebook = clinic.facebook ? clinic.facebook : '';
          self.clinicData.website = clinic.website ? clinic.website : '';
          self.clinicData.clinicAddress1 = clinic.clinicAddress1
            ? clinic.clinicAddress1
            : '';
          self.clinicData.isResidentialAddress = clinic.isResidentialAddress
            ? clinic.isResidentialAddress
            : '';
          self.clinicData.haveAdrenalineAndHyalaseInClinic =
            clinic.haveAdrenalineAndHyalaseInClinic
              ? clinic.haveAdrenalineAndHyalaseInClinic
              : '';
          self.clinicData.intendToSecureS4Medication =
            clinic.intendToSecureS4Medication
              ? clinic.intendToSecureS4Medication
              : '';
          self.clinicData.abnCertificate = clinic.abnCertificate
            ? clinic.abnCertificate
            : '';
          self.clinicData.councilPermits = clinic.councilPermits
            ? clinic.councilPermits
            : [];
          self.clinicData.poisonsCertificate = clinic.poisonsCertificate
            ? clinic.poisonsCertificate
            : [];
          self.clinicData.clinicOpeningHours = clinic.clinicOpeningHours
            ? clinic.clinicOpeningHours
            : {
                mondays: '',
                tuesdays: '',
                wednesdays: '',
                thursdays: '',
                fridays: '',
                saturdays: '',
                sundays: '',
              };
          self.clinicData.clinicFrontPhoto = clinic.clinicFrontPhoto
            ? clinic.clinicFrontPhoto
            : [];
          self.clinicData.clinicFloorPhoto = clinic.clinicFloorPhoto
            ? clinic.clinicFloorPhoto
            : [];
          self.clinicData.clinicTreatmentBedPhoto =
            clinic.clinicTreatmentBedPhoto
              ? clinic.clinicTreatmentBedPhoto
              : [];
          self.clinicData.clinicDrawingUpAreaPhoto =
            clinic.clinicDrawingUpAreaPhoto
              ? clinic.clinicDrawingUpAreaPhoto
              : [];
          self.clinicData.clinicFridgePhoto = clinic.clinicFridgePhoto
            ? clinic.clinicFridgePhoto
            : [];
          self.clinicData.clinicDrugStoragePhoto = clinic.clinicDrugStoragePhoto
            ? clinic.clinicDrugStoragePhoto
            : [];
          self.clinicData.clinicBinsPhoto = clinic.clinicBinsPhoto
            ? clinic.clinicBinsPhoto
            : [];
          self.clinicData.clinicRoomLockPhoto = clinic.clinicRoomLockPhoto
            ? clinic.clinicRoomLockPhoto
            : [];
          self.clinicData.clinicEpipenAndHyalasePhoto =
            clinic.clinicEpipenAndHyalasePhoto
              ? clinic.clinicEpipenAndHyalasePhoto
              : [];
          self.clinicData.isProfileCompleted =
            clinic.isProfileCompleted || false;
          return this.fetchSuppliers();
        })
        .then((suppliers) => {
          this.suppliers = suppliers.data.data;
        });
    },
    async getDiscountList() {
      let self = this;
      await this.fetchDiscountList().then((response) => {
        self.discounts = response.data.data;
      });
    },
    onSuccessfullyVerified(verifiedAt) {
      this.clinicData.emailVerifiedAt = verifiedAt;
    },
    async saveData() {
      let self = this;

      let isValid = await this.$validator.validateAll('basic');

      if (
        this.$store.state.AppActiveUser.userType !== 'superAdmin' &&
        this.$store.state.AppActiveUser.userType !== 'admin' &&
        this.$store.state.AppActiveUser.userType !== 'franchise' &&
        this.$store.state.AppActiveUser.userType !== 'subFranchise'
      ) {
        isValid = await this.$validator.validate();
        isValid = await this.$refs.stepTwoRef.$validator.validate();
        isValid = await this.$refs.stepThreeRef.$validator.validate();
        isValid = await this.$refs.step4Ref.$validator.validate();
        isValid = await this.$refs.step5Ref.$validator.validate();
        isValid = await this.$refs.step6Ref.$validator.validate();
        isValid = await this.$refs.step7Ref.$validator.validate();
        isValid = await this.$refs.step8Ref.$validator.validate();
        isValid = await this.$refs.step9Ref.$validator.validate();
        isValid = await this.$refs.step10Ref.$validator.validate();
        isValid = await this.$refs.step11Ref.$validator.validate();

        if (self.clinicData.isResidentialAddress === '') {
          isValid = false;
          this.validationKeys.showIsResidentialAddressError = true;
        } else {
          this.validationKeys.showIsResidentialAddressError = false;
        }

        if (self.clinicData.intendToSecureS4Medication === '') {
          isValid = false;
          this.validationKeys.showIntendToSecureS4MedicationError = true;
        } else {
          this.validationKeys.showIntendToSecureS4MedicationError = false;
        }

        if (self.clinicData.haveAdrenalineAndHyalaseInClinic === '') {
          isValid = false;
          this.validationKeys.showHaveAdrenalineAndHyalaseInClinicError = true;
        } else {
          this.validationKeys.showHaveAdrenalineAndHyalaseInClinicError = false;
        }

        if (self.clinicData.abnCertificate == '') {
          this.errors.add({
            field: 'abnCertificate',
            msg: 'ABN Certificate is required',
          });
          document.getElementById('abnCertificateId').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('abnCertificateId').style.borderColor =
            '#cccccc';
          this.errors.remove('abnCertificate');
        }

        if (self.clinicData.clinicFrontPhoto.length === 0) {
          this.$refs.stepThreeRef.errors.add({
            field: 'clinicFrontPhoto',
            msg: 'Clinic Front Photo is required',
          });
          document.getElementById('clinicFrontPhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicFrontPhoto').style.borderColor =
            '#cccccc';
          this.$refs.stepThreeRef.errors.remove('clinicFrontPhoto');
        }

        if (self.clinicData.clinicFloorPhoto.length === 0) {
          this.$refs.step4Ref.errors.add({
            field: 'clinicFloorPhoto',
            msg: 'Clinic Floor Photo is required',
          });
          document.getElementById('clinicFloorPhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicFloorPhoto').style.borderColor =
            '#cccccc';
          this.$refs.step4Ref.errors.remove('clinicFloorPhoto');
        }

        if (self.clinicData.clinicTreatmentBedPhoto.length === 0) {
          this.$refs.step5Ref.errors.add({
            field: 'clinicTreatmentBedPhoto',
            msg: 'Clinic Treatment Bed Photo is required',
          });
          document.getElementById('clinicTreatmentBedPhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicTreatmentBedPhoto').style.borderColor =
            '#cccccc';
          this.$refs.step5Ref.errors.remove('clinicTreatmentBedPhoto');
        }

        if (self.clinicData.clinicDrawingUpAreaPhoto.length === 0) {
          this.$refs.step6Ref.errors.add({
            field: 'clinicDrawingUpAreaPhoto',
            msg: 'Clinic Drawing Up Area Photo is required',
          });
          document.getElementById(
            'clinicDrawingUpAreaPhoto'
          ).style.borderColor = '#ea5455';
          isValid = false;
        } else {
          document.getElementById(
            'clinicDrawingUpAreaPhoto'
          ).style.borderColor = '#cccccc';
          this.$refs.step6Ref.errors.remove('clinicDrawingUpAreaPhoto');
        }

        if (self.clinicData.clinicFridgePhoto.length === 0) {
          this.$refs.step7Ref.errors.add({
            field: 'clinicFridgePhoto',
            msg: 'Clinic Fridge Photo is required',
          });
          document.getElementById('clinicFridgePhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicFridgePhoto').style.borderColor =
            '#cccccc';
          this.$refs.step7Ref.errors.remove('clinicFridgePhoto');
        }

        if (self.clinicData.clinicDrugStoragePhoto.length === 0) {
          this.$refs.step8Ref.errors.add({
            field: 'clinicDrugStoragePhoto',
            msg: 'Clinic Drug Storage Photo is required',
          });
          document.getElementById('clinicDrugStoragePhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicDrugStoragePhoto').style.borderColor =
            '#cccccc';
          this.$refs.step8Ref.errors.remove('clinicDrugStoragePhoto');
        }

        if (self.clinicData.clinicBinsPhoto.length === 0) {
          this.$refs.step9Ref.errors.add({
            field: 'clinicBinsPhoto',
            msg: 'Clinic Bins Photo is required',
          });
          document.getElementById('clinicBinsPhoto').style.borderColor =
            '#ea5455';
          isValid = false;
        } else {
          document.getElementById('clinicBinsPhoto').style.borderColor =
            '#cccccc';
          this.$refs.step9Ref.errors.remove('clinicBinsPhoto');
        }
      }

      if (
        !self.clinicData.address.geometry.coordinates[0] ||
        self.checkDisplayAddress != self.clinicData.address.displayAddress
      ) {
        isValid = false;
        this.errors.add({
          field: 'displayAddress',
          msg: 'Enter valid address.',
        });
      } else {
        this.errors.remove('displayAddress');
      }

      if (isValid) {
        self.$vs.loading();
        await this.updateClinicDetail({
          id: this.clinicId,
          data: this.clinicData,
        })
          .then(() => {
            this.$vs.notify({
              title: 'Success',
              text: 'Clinic updated successfully.',
              color: 'success',
            });
            this.statusChangedClick = false;
            self.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.notify({
              title: 'Failed',
              text: 'Failed to update clinic. Try again!',
              color: 'danger',
            });
            this.statusChangedClick = false;

            if (err.status === 422) {
              this.mapServerErrors(this, err, 'basic');
            }
            if (err.status === 417) {
              if (err.data.title === 'Invalid email') {
                this.errors.add({
                  field: 'email',
                  msg: err.data.message,
                  scope: 'basic',
                });
              } else if (err.data.title === 'Invalid ABN') {
                this.errors.add({
                  field: 'abn',
                  msg: err.data.message,
                  scope: 'basic',
                });
              }
            }

            self.$vs.loading.close();
          });
      }
    },
    async changeAdminApproval(status) {
      this.adminApprovalChangeClick = true;
      await this.updateClinicDetail({
        id: this.clinicId,
        data: { hasApprovedByAdmin: !status },
      })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Admin approval updated successfully.',
            color: 'success',
          });
          this.adminApprovalChangeClick = false;
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Failed',
            text: 'Failed to update admin approval. Try again!',
            color: 'danger',
          });
          this.adminApprovalChangeClick = false;
        });
    },
    async changeDiscountEnable(status) {
      this.discountEnableChangeClick = true;
      await this.updateClinicDetail({
        id: this.clinicId,
        data: { isEnableProductDiscount: !status },
      })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Discount enable updated successfully.',
            color: 'success',
          });
          this.discountEnableChangeClick = false;
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Failed',
            text: 'Failed to update discount enable. Try again!',
            color: 'danger',
          });
          this.discountEnableChangeClick = false;
        });
    },
    mapServerErrors(self, err) {
      let data = err.data.data.details;
      data.map(function (value) {
        self.errors.add({
          field: value.context.key,
          msg: value.message.replace(/"/g, ''),
        });
      });
    },
  },
  async mounted() {
    await loadGoogleMapsPlaces();

    // eslint-disable-next-line no-undef
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ['geocode'], componentRestrictions: { country: 'au' } }
    );
    this.autocomplete.addListener('place_changed', () => {
      let place = this.autocomplete.getPlace();
      this.errors.remove('displayAddress');
      this.addressData = place.address_components;
      this.checkDisplayAddress = place.formatted_address;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      this.clinicData.address.displayAddress = place.formatted_address;
      this.clinicData.address.geometry.coordinates[0] = lon;
      this.clinicData.address.geometry.coordinates[1] = lat;

      let self = this;

      self.clinicData.address.suburb = '';
      self.clinicData.address.state = '';
      self.clinicData.address.postCode = '';
      if (
        place &&
        place.address_components &&
        place.address_components.length > 0
      ) {
        place.address_components.forEach(function (gAdd) {
          if (gAdd.types[0] === 'administrative_area_level_2') {
            self.clinicData.address.suburb = gAdd.long_name;
            self.errors.remove('clinicSuburb');
          }
          if (gAdd.types[0] === 'administrative_area_level_1') {
            self.clinicData.address.state = gAdd.long_name;
            self.errors.remove('clinicState');
          }
          if (gAdd.types[0] === 'postal_code') {
            self.clinicData.address.postCode = gAdd.long_name;
            self.errors.remove('clinicPostCode');
          }
        });
      }
    });
  },
  async created() {
    let clinicId = this.$route.params.clinicId;
    await this.getClinicDetail(clinicId);
    this.isRequired =
      this.$store.state.AppActiveUser.userType === 'superAdmin' ||
      this.$store.state.AppActiveUser.userType === 'admin' ||
      this.$store.state.AppActiveUser.userType === 'franchise' ||
      this.$store.state.AppActiveUser.userType === 'subFranchise'
        ? false
        : true;
    await this.getDiscountList();
  },
  watch: {
    'clinicData.isResidentialAddress': function (newVal) {
      if (newVal !== '') {
        this.validationKeys.showIsResidentialAddressError = false;
      }
    },
    'clinicData.intendToSecureS4Medication': function (newVal) {
      if (newVal !== '') {
        this.validationKeys.showIntendToSecureS4MedicationError = false;
      }
    },
    'clinicData.haveAdrenalineAndHyalaseInClinic': function (newVal) {
      if (newVal !== '') {
        this.validationKeys.showHaveAdrenalineAndHyalaseInClinicError = false;
      }
    },
  },
  beforeDestroy() {
    EventBus.$emit('closePopup');
  },
};
</script>

<style scoped>
.error-text {
  font-size: 0.65rem !important;
  padding: 2px 4px 4px;
  display: block;
  margin-top: -6px;
}

.no-margin-span {
  margin-top: 0 !important;
}
</style>
